import React, { useEffect, useMemo, useState, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import classNames from 'classnames/bind';

import styles from './Account.module.scss';
import AccountHeader from './AccountHeader';
import OverviewPanel from './OverviewPanel';
import AccountToolbar from './AccountToolbar';
import UserGrid from './UserGrid';
import CreateAccountModal from './CreateAccountModal';
import DirectoryModal from './DirectoryModal';
import { showToast } from "../../Components/ToastMessage";

import { loginSuccess } from '../../redux/authSlice';
import { createAxios } from '../../createInstance';
import {
    getAlluser,
    registerUser,
    getDepartment,
    getPosition,
    createDepartment,
    createPosition,
    deleteUser,
} from '../../redux/apiRequest';

const cx = classNames.bind(styles);
function Account() {
    const dispatch = useDispatch();
    const currentUser = useSelector((state) => state.auth.login?.currentUser);
    const userState = useSelector((state) => state.auth.allusers);
    const departmentsState = useSelector((state) => state.departments);
    const positionsState = useSelector((state) => state.positions);

    const users = Array.isArray(userState?.listusers?.users) ? userState.listusers.users : [];
    console.log(users)
    const departmentsList = Array.isArray(departmentsState?.departments?.listdepartments)
        ? departmentsState.departments.listdepartments
        : [];
    const positionsList = Array.isArray(positionsState?.positions?.listpositions)
        ? positionsState.positions.listpositions
        : [];

    const axiosJWT = useMemo(() => createAxios(currentUser, dispatch, loginSuccess), [currentUser, dispatch]);

    const [searchTerm, setSearchTerm] = useState('');
    const [isCreateModalOpen, setIsCreateModalOpen] = useState(false);
    
    const [selectedDepartment, setSelectedDepartment] = useState('');
    const [selectedPosition, setSelectedPosition] = useState('');
    const [deletingUserId, setDeletingUserId] = useState(null);
    const [formValues, setFormValues] = useState({
        username: '',
        fullname: '',
        email: '',
        password: '',
        department: '',
        position: '',
    });
    const [formErrors, setFormErrors] = useState({});
    const [submitError, setSubmitError] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);

    

        const departmentLookup = useMemo(() => {
        if (!Array.isArray(departmentsList)) return new Map();
        const map = new Map();
        departmentsList.forEach((item) => {
            if (!item) return;
            const rawId =
                item?._id ??
                item?.id ??
                item?.value ??
                item?.code ??
                item?.slug ??
                item?.key ??
                item;
            if (rawId == null) return;
            const id = String(rawId).trim();
            if (!id) return;
            const rawLabel =
                item?.name ??
                item?.title ??
                item?.label ??
                item?.displayName ??
                item?.value ??
                item?.code ??
                item?.slug ??
                item?.key ??
                id;
            const label = rawLabel != null ? String(rawLabel).trim() : '';
            map.set(id, label || id);
        });
        return map;
    }, [departmentsList]);

    const positionLookup = useMemo(() => {
        if (!Array.isArray(positionsList)) return new Map();
        const map = new Map();
        positionsList.forEach((item) => {
            if (!item) return;
            const rawId =
                item?._id ??
                item?.id ??
                item?.value ??
                item?.code ??
                item?.slug ??
                item?.key ??
                item;
            if (rawId == null) return;
            const id = String(rawId).trim();
            if (!id) return;
            const rawLabel =
                item?.name ??
                item?.title ??
                item?.label ??
                item?.displayName ??
                item?.value ??
                item?.code ??
                item?.slug ??
                item?.key ??
                id;
            const label = rawLabel != null ? String(rawLabel).trim() : '';
            map.set(id, label || id);
        });
        return map;
    }, [positionsList]);

    const enrichedUsers = useMemo(
        () =>
            users.map((user) => {
                const departmentId = user?.department ? String(user.department).trim() : '';
                const positionId = user?.position ? String(user.position).trim() : '';
                return {
                    ...user,
                    departmentId,
                    positionId,
                    departmentName: departmentLookup.get(departmentId) || '',
                    positionName: positionLookup.get(positionId) || '',
                };
            }),
        [users, departmentLookup, positionLookup]
    );

    const departmentOptionsForForm = useMemo(() => {
        if (!Array.isArray(departmentsList)) return [];
        const seen = new Set();
        return departmentsList
            .map((item) => {
                if (!item) return null;
                const rawValue =
                    item?._id ??
                    item?.id ??
                    item?.value ??
                    item?.code ??
                    item?.slug ??
                    item?.key ??
                    item;
                const value = rawValue != null ? String(rawValue).trim() : '';
                if (!value) return null;
                const label = departmentLookup.get(value) || value;
                return { value, label };
            })
            .filter(Boolean)
            .filter((option) => {
                const key = option.value.toLowerCase();
                if (seen.has(key)) return false;
                seen.add(key);
                return true;
            });
    }, [departmentsList, departmentLookup]);

    const positionOptionsForForm = useMemo(() => {
        if (!Array.isArray(positionsList)) return [];
        const seen = new Set();
        return positionsList
            .map((item) => {
                if (!item) return null;
                const rawValue =
                    item?._id ??
                    item?.id ??
                    item?.value ??
                    item?.code ??
                    item?.slug ??
                    item?.key ??
                    item;
                const value = rawValue != null ? String(rawValue).trim() : '';
                if (!value) return null;
                const label = positionLookup.get(value) || value;
                return { value, label };
            })
            .filter(Boolean)
            .filter((option) => {
                const key = option.value.toLowerCase();
                if (seen.has(key)) return false;
                seen.add(key);
                return true;
            });
    }, [positionsList, positionLookup]);
const [directoryModal, setDirectoryModal] = useState({ open: false, mode: 'department' });
    const [directoryCreating, setDirectoryCreating] = useState(false);

    const loadUsers = useCallback(() => {
        if (currentUser?.accessToken) {
            getAlluser(currentUser.accessToken, dispatch, axiosJWT);
        }
    }, [currentUser?.accessToken, dispatch, axiosJWT]);

    useEffect(() => {
        loadUsers();
    }, [loadUsers]);

    useEffect(() => {
        if (!currentUser?.accessToken) return;
        if (!departmentsList.length) {
            getDepartment(currentUser.accessToken, dispatch, axiosJWT);
        }
        if (!positionsList.length) {
            getPosition(currentUser.accessToken, dispatch, axiosJWT);
        }
    }, [
        axiosJWT,
        currentUser?.accessToken,
        departmentsList.length,
        dispatch,
        positionsList.length,
    ]);

    const handleSearchChange = (event) => {
        setSearchTerm(event.target.value);
    };

    const handleDepartmentChange = (event) => {
        setSelectedDepartment(event.target.value);
    };

    const handlePositionChange = (event) => {
        setSelectedPosition(event.target.value);
    };

    const handleDeleteUser = useCallback(async (userId) => {
        if (!currentUser?.accessToken || !userId) return;

        setDeletingUserId(userId);

        const successCallback = async () => {
            setDeletingUserId(null);
            loadUsers();
            showToast({
                type: "success",
                title: "Thành công!",
                message: "Đã vô hiệu hóa tài khoản.",
                duration: 3000,
            });
        };

        const errorCallback = async () => {
            setDeletingUserId(null);
            showToast({
                type: "error",
                title: "Thất bại!",
                message: "Không thể vô hiệu hóa tài khoản. Vui lòng thử lại.",
                duration: 3000,
            });
        };

        try {
            await deleteUser(userId, dispatch, successCallback, errorCallback, currentUser.accessToken, axiosJWT);
        } catch (error) {
            await errorCallback();
        }
    }, [axiosJWT, currentUser?.accessToken, dispatch, loadUsers]);

    const handleOpenCreateModal = () => {
        setFormValues({
            username: '',
            fullname: '',
            email: '',
            password: '',
            department: '',
            position: '',
        });
        setFormErrors({});
        setSubmitError('');
        setIsCreateModalOpen(true);
    };

    const handleCloseCreateModal = () => {
        if (isSubmitting) return;
        setIsCreateModalOpen(false);
        setFormValues({
            username: '',
            fullname: '',
            email: '',
            password: '',
            department: '',
            position: '',
        });
        setFormErrors({});
        setSubmitError('');
    };

    const handleFormChange = (event) => {
        const { name, value } = event.target;
        setFormValues((prev) => ({ ...prev, [name]: value }));
        setFormErrors((prev) => ({ ...prev, [name]: '' }));
        setSubmitError('');
    };

    const validateForm = () => {
        const errors = {};
        if (!formValues.username.trim()) errors.username = 'Vui lòng nhập tên đăng nhập.';
        if (!formValues.fullname.trim()) errors.fullname = 'Vui lòng nhập họ và tên.';
        if (!formValues.password.trim()) errors.password = 'Vui lòng nhập mật khẩu.';
        if (formValues.password && formValues.password.length < 8) errors.password = 'Mật khẩu phải từ 8 ký tự.';
        if (!formValues.department.trim()) errors.department = 'Vui lòng chọn phòng ban.';
        if (!formValues.position.trim()) errors.position = 'Vui lòng chọn chức vụ.';
        return errors;
    };

    const handleCreateUser = async (event) => {
        event.preventDefault();
        if (!currentUser?.accessToken) return;

        const errors = validateForm();
        if (Object.keys(errors).length > 0) {
            setFormErrors(errors);
            return;
        }

        setIsSubmitting(true);
        setSubmitError('');

        const payload = {
            username: formValues.username.trim(),
            fullname: formValues.fullname.trim(),
            email: formValues.email.trim(),
            password: formValues.password.trim(),
            department: formValues.department.trim(),
            position: formValues.position.trim(),
        };

        const successCallback = async () => {
            showToast({
                type: "success",
                title: "Thành công!",
                message: "Thêm mới thành công.",
                duration: 3000,
            });
            await loadUsers();
            setIsSubmitting(false);
            setFormValues({
                username: '',
                fullname: '',
                email: '',
                password: '',
                department: '',
                position: '',
            });
            setFormErrors({});
            setSubmitError('');
            setIsCreateModalOpen(false);
        };

        const errorCallback = async () => {
            setIsSubmitting(false);
            setSubmitError('Không thể tạo tài khoản. Vui lòng thử lại.');
        };

        try {
            await registerUser(payload, dispatch, successCallback, errorCallback, currentUser.accessToken, axiosJWT);
        } catch (error) {
            setIsSubmitting(false);
            setSubmitError('Đã xảy ra lỗi, vui lòng thử lại.');
        }
    };

    const normalizeText = useCallback((value) => {
        if (!value) return '';
        if (typeof value === 'string') return value.trim().toLowerCase();
        if (typeof value === 'object') {
            const derived =
                value.name ||
                value.title ||
                value.label ||
                value.value ||
                value.departmentName ||
                value.positionName;
            return derived ? String(derived).trim().toLowerCase() : '';
        }
        return String(value).trim().toLowerCase();
    }, []);

    const filteredUsers = enrichedUsers.filter((user) => {
        const query = searchTerm.trim().toLowerCase();
        const departmentFilter = selectedDepartment.trim().toLowerCase();
        const positionFilter = selectedPosition.trim().toLowerCase();

        const valuesForSearch = [
            user.username,
            user.fullname,
            user.email,
            user.departmentName,
            user.positionName,
            user.departmentId,
            user.positionId,
        ]
            .filter(Boolean)
            .map(normalizeText);

        const matchesSearch = !query ? true : valuesForSearch.some((value) => value.includes(query));

        if (!matchesSearch) return false;

        const userDepartmentValue = normalizeText(user.departmentId);
        const userPositionValue = normalizeText(user.positionId);

        const matchesDepartment = !departmentFilter || userDepartmentValue === departmentFilter;
        const matchesPosition = !positionFilter || userPositionValue === positionFilter;

        return matchesDepartment && matchesPosition;
    });


    const handleOpenDirectory = useCallback((mode) => {
        if (!currentUser?.accessToken) return;
        setDirectoryCreating(false);
        setDirectoryModal({ open: true, mode });
        if (mode === 'department') {
            getDepartment(currentUser.accessToken, dispatch, axiosJWT);
        } else {
            getPosition(currentUser.accessToken, dispatch, axiosJWT);
        }
    }, [currentUser?.accessToken, dispatch, axiosJWT]);

    const handleCloseDirectory = useCallback(() => {
        if (directoryCreating) return;
        setDirectoryModal((prev) => ({ ...prev, open: false }));
    }, [directoryCreating]);

    const handleDirectoryCreate = useCallback(async (name) => {
        if (!currentUser?.accessToken) return false;
        setDirectoryCreating(true);

        let isSuccess = false;

        const successCallback = async () => {
            showToast({
                type: "success",
                title: "Thành công!",
                message: "Thêm mới thành công.",
                duration: 3000
            });
            if (directoryModal.mode === 'department') {
                await getDepartment(currentUser.accessToken, dispatch, axiosJWT);
            } else {
                await getPosition(currentUser.accessToken, dispatch, axiosJWT);
            }
            setDirectoryCreating(false);
            isSuccess = true;
        };

        const errorCallback = async () => {
            setDirectoryCreating(false);
            showToast({
                type: "error",
                title: "Thất bại!",
                message: "Vui lòng thử lại sau.",
                duration: 3000,
            });
        };

        try {
            if (directoryModal.mode === 'department') {
                await createDepartment(dispatch, currentUser.accessToken, { name }, axiosJWT, successCallback, errorCallback);
            } else {
                await createPosition(dispatch, currentUser.accessToken, { name }, axiosJWT, successCallback, errorCallback);
            }
        } catch (error) {
            setDirectoryCreating(false);

        }

        return isSuccess;
    }, [axiosJWT, currentUser?.accessToken, directoryModal.mode, dispatch]);

    const isUsersLoading = Boolean(userState?.isFetching);
    const directoryItems = directoryModal.mode === 'department' ? departmentsList : positionsList;
    const directoryLoading = directoryModal.mode === 'department'
        ? Boolean(departmentsState?.departments?.isFetching)
        : Boolean(positionsState?.positions?.isFetching);

    return (
        <section className={cx('account-page')}>
            <AccountHeader isRefreshing={isUsersLoading} onRefresh={loadUsers} />

            <OverviewPanel
                totalUsers={userState?.listusers?.totalUsers}
                totalDepartments={userState?.listusers?.totalDepartments}
                totalPositions={userState?.listusers?.totalPositions}
                onOpenDepartments={() => handleOpenDirectory('department')}
                onOpenPositions={() => handleOpenDirectory('position')}
            />

            <AccountToolbar
                searchTerm={searchTerm}
                onSearchChange={handleSearchChange}
                departments={departmentsList}
                positions={positionsList}
                selectedDepartment={selectedDepartment}
                selectedPosition={selectedPosition}
                onDepartmentChange={handleDepartmentChange}
                onPositionChange={handlePositionChange}
                onOpenCreate={handleOpenCreateModal}
            />

            <div className={cx('content-panel')}>
                <UserGrid
                isLoading={isUsersLoading}
                filteredUsers={filteredUsers}
                onDeleteUser={handleDeleteUser}
                deletingUserId={deletingUserId}
            />
            </div>

            <CreateAccountModal
                isOpen={isCreateModalOpen}
                isSubmitting={isSubmitting}
                formValues={formValues}
                formErrors={formErrors}
                submitError={submitError}
                departmentOptions={departmentOptionsForForm}
                positionOptions={positionOptionsForForm}
                onClose={handleCloseCreateModal}
                onChange={handleFormChange}
                onSubmit={handleCreateUser}
            />

            <DirectoryModal
                open={directoryModal.open}
                mode={directoryModal.mode}
                items={directoryItems}
                isLoading={directoryLoading}
                isCreating={directoryCreating}
                // actionError={directoryActionError}
                onClose={handleCloseDirectory}
                onCreate={handleDirectoryCreate}
            />
        </section>
    );
}

export default Account;
































